import OnboardingPage from "./../components/OnboardingPage";



export default function Onboarding() {
  return <OnboardingPage />;
}
